/* eslint-disable no-underscore-dangle */

import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import getAPI from '../../api/iv-back';
import { logout } from '../api-auth/actions';
import { updatePersistedCirculationsFilters } from '../circulations/saga';
import { sagaWithCallback } from '../utils';
import {
  fetchInitializeCommunication,
  fetchedInitializeCommunication,
  fetchedSaveCommunications,
  saveCommunications,
} from './actions';

type initializeCommunicationPayload = ReturnType<typeof fetchInitializeCommunication>;
type FetchSaveCommunicationsActionPayload = ReturnType<typeof saveCommunications>;

function* initializeCommunicationSaga({ payload }: initializeCommunicationPayload) {
  const { getInitializeCommunication } = getAPI();
  const response: YieldOf<typeof getInitializeCommunication> = yield call(getInitializeCommunication, payload);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedInitializeCommunication(data));
    if (payload?.IsBulkCommunication && data?.isValid) {
      const circulationsFilters = { ...payload };
      delete circulationsFilters.IsBulkCommunication;
      yield call(updatePersistedCirculationsFilters, circulationsFilters);
    }
    return data;
  } else {
    const error = problem || 'unknown';
    yield put(fetchedInitializeCommunication(undefined, error));
    throw new Error('initialize communication problem ' + problem);
  }
}

export function* saveCommunicationsSaga({ payload }: FetchSaveCommunicationsActionPayload) {
  const { saveCommunications } = getAPI();
  const response: YieldOf<typeof saveCommunications> = yield call(saveCommunications, payload);
  const { data, ok, problem, status } = response;

  if (status === 401 || status === 403) {
    yield put(logout());
  }

  if (!ok) {
    const error = problem || 'unknown';

    if (status === 400 || status === 412) {
      /**
       * status === 400 FOR DifferedError OR Step1Error
       * status === 412 FOR DvNumbersError
       */
      yield put(fetchedSaveCommunications(data, error));

      if (data?.message?.includes('deffered')) {
        throw new Error('Deffered Error');
      }
      if (data?.message?.includes('SelectedCarriages')) {
        throw new Error('Step1 Error');
      }
    } else {
      yield put(fetchedSaveCommunications(undefined, error));
    }

    throw new Error('SaveCommunication Error ' + problem);
  }

  return data;
}

export default function* SaveCommunicationSaga() {
  yield takeLatest(fetchInitializeCommunication.type, sagaWithCallback(initializeCommunicationSaga));
  yield takeLatest(saveCommunications.type, sagaWithCallback(saveCommunicationsSaga));
}
